let environment;
let isLocalOrIntegrationEnv = false;

const prod = {
  apiUrl: "https://api2.bearwww.com/api",
}

const integration = {
  apiUrl: "https://api2.dev.bearwww.com/api",
}

const dev = {
  apiUrl: "http://localhost:3000/api",
}

if (process.env.NODE_ENV === "development") {
  environment = dev;
  isLocalOrIntegrationEnv = true;
} else if (window.location.host === "moderation.dev.bearwww.com") {
  // Using same env detection logic as bearwww project but this is NOT the way
  // FIXME please refactor this to use a better method @jsdevs
  environment = integration;
  isLocalOrIntegrationEnv = true;
} else {
  environment = prod;
  isLocalOrIntegrationEnv = false;
}

const config = {
  environment,
  isLocalOrIntegrationEnv,
};

export default config;
